export default __webpack_public_path__ + "static/media/circularjeansid.0fee6530.mp4";